import type {ReactNode} from 'react';
import {DefaultControl} from './DefaultControl';
import {DefaultMenuList} from './DefaultMenuList';
import {DefaultOption} from './DefaultOption';
import {DefaultMultiValueChip} from './DefaultMultiValueChip';
import {DefaultCreateOption} from './DefaultCreateOption';
import type {SelectComponents} from './types';
import type {SelectValue} from '../types';

function defaultComponents<T, V extends SelectValue, L extends ReactNode>(): Required<
  SelectComponents<T, V, L>
> {
  return {
    Control: DefaultControl,
    MenuList: DefaultMenuList,
    Option: DefaultOption,
    MultiValueChip: DefaultMultiValueChip,
    CreateOption: DefaultCreateOption,
  } as Required<SelectComponents<T, V, L>>;
}

function mergeComponents<T, V extends SelectValue, L extends ReactNode>(
  overrides?: SelectComponents<T, V, L>,
): Required<SelectComponents<T, V, L>> {
  const defaults = defaultComponents<T, V, L>();
  if (!overrides) return defaults;
  return {
    Control: overrides.Control ?? defaults.Control,
    MenuList: overrides.MenuList ?? defaults.MenuList,
    Option: overrides.Option ?? defaults.Option,
    MultiValueChip: overrides.MultiValueChip ?? defaults.MultiValueChip,
    CreateOption: overrides.CreateOption ?? defaults.CreateOption,
  };
}

export {defaultComponents, mergeComponents};
